import JNotifications from "./JNotifications";

export { JNotifications }
export default JNotifications
